const Menu = {
  guest: [
    {
      route_name: "home",
      title: "Beranda",
    },
    {
      route_name: "profile",
      title: "Profil",
    },
    {
      title: "Produk Pembiayaan",
      group_route_name: "product",
      child: [
        {
          route_name: "product_faq",
          title: "Dana Multi Guna",
        },
        {
          product_name: "maxi-travel",
          title: "Maxi Travel",
        },
        {
          product_name: "maxi-edukasi",
          title: "Maxi Edukasi",
        },
        {
          product_name: "maxi-usaha",
          title: "Maxi Usaha",
        },
        {
          product_name: "maxi-sehat",
          title: "Maxi Sehat",
        },
        {
          product_name: "maxi-extraguna",
          title: "Maxi Extraguna",
        },
      ],
    },
    {
      route_name: "simulasi_cicilan",
      title: "Simulasi Cicilan",
    },
    {
      route_name: "mitra_bisnis",
      title: "Mitra Bisnis",
    },
    {
      route_name: "axi",
      title: "AXI",
    },
    {
      route_name: "gudang_info",
      title: "Gudang Info",
    },
  ],
  nasabah: [
    {
      route_name: "home",
      title: "Beranda",
    },
    {
      route_name: "produk_data_tunai_confirmation",
      title: "Submit Order",
    },
    {
      route_name: "profile",
      title: "Profil",
    },
    {
      title: "Produk Pembiayaan",
      group_route_name: "product",
      child: [
        {
          route_name: "product_faq",
          title: "Dana Multi Guna",
        },
        {
          product_name: "maxi-travel",
          title: "Maxi Travel",
        },
        {
          product_name: "maxi-edukasi",
          title: "Maxi Edukasi",
        },
        {
          product_name: "maxi-usaha",
          title: "Maxi Usaha",
        },
        {
          product_name: "maxi-sehat",
          title: "Maxi Sehat",
        },
        {
          product_name: "maxi-extraguna",
          title: "Maxi Extraguna",
        },
      ],
    },
    {
      route_name: "simulasi_cicilan",
      title: "Simulasi Cicilan",
    },
    {
      route_name: "mitra_bisnis",
      title: "Mitra Bisnis",
    },
    {
      route_name: "axi",
      title: "AXI",
    },
    {
      route_name: "gudang_info",
      title: "Gudang Info",
    },
  ],
  axi: [
    {
      route_name: "home",
      title: "Beranda",
    },
    {
      route_name: "produk_data_tunai_confirmation",
      title: "Submit Order",
    },
    {
      route_name: "profile",
      title: "Profil",
    },
    {
      title: "Produk Pembiayaan",
      group_route_name: "product",
      child: [
        {
          route_name: "produk_data_tunai_confirmation",
          title: "Dana Multi Guna"
        },
        {
          product_name: "maxi-travel",
          title: "Maxi Travel",
        },
        {
          product_name: "maxi-edukasi",
          title: "Maxi Edukasi",
        },
        {
          product_name: "maxi-usaha",
          title: "Maxi Usaha",
        },
        {
          product_name: "maxi-sehat",
          title: "Maxi Sehat",
        },
        {
          product_name: "maxi-extraguna",
          title: "Maxi Extraguna",
        },
      ],
    },
    {
      route_name: "simulasi_cicilan",
      title: "Simulasi Cicilan",
    },
    {
      route_name: "mitra_bisnis",
      title: "Mitra Bisnis",
    },
    {
      title: "AXI",
      group_route_name: "axi",
      role: "axi",
      child: [
        {
          route_name: "axi_berita_terbaru_web",
          title: "Berita Terbaru",
        },
        {
          route_name: "axi_info",
          title: "Info AXI",
        },
        {
          route_name: "axi_unduh_materi",
          title: "Unduh Materi",
        },
        {
          route_name: "download_report_ppd",
          title: "Unduh Report PPD",
        },
        {
          route_name: "axi_unduh_epks",
          title: "Unduh EPKS",
        },
        {
          route_name: "axi_testimonial",
          title: "Kisah Sukses",
        },
        {
          route_name: "axi_register",
          title: "Daftarkan Rekan Bisnis",
        },
        {
          route_name: "axi_profile",
          title: "Profil Saya",
        },
      ],
    },
    {
      route_name: "gudang_info",
      title: "Gudang Info",
    },
  ],
  sales_head: [
    {
      route_name: "home",
      title: "Beranda",
    },
    {
      route_name: "produk_data_tunai_confirmation",
      title: "Submit Order",
    },
    {
      route_name: "profile",
      title: "Profil",
    },
    {
      title: "Produk Pembiayaan",
      group_route_name: "product",
      child: [
        {
          route_name: "produk_data_tunai_confirmation",
          title: "Dana Multi Guna",
        },
        {
          product_name: "maxi-travel",
          title: "Maxi Travel",
        },
        {
          product_name: "maxi-edukasi",
          title: "Maxi Edukasi",
        },
        {
          product_name: "maxi-usaha",
          title: "Maxi Usaha",
        },
        {
          product_name: "maxi-sehat",
          title: "Maxi Sehat",
        },
        {
          product_name: "maxi-extraguna",
          title: "Maxi Extraguna",
        },
      ],
    },
    {
      route_name: "simulasi_cicilan",
      title: "Simulasi Cicilan",
    },
    {
      route_name: "mitra_bisnis",
      title: "Mitra Bisnis",
    },
    {
      title: "AXI",
      group_route_name: "sales_head",
      role: "sales head",
      child: [
        {
          route_name: "axi_register",
          query: { isCrh: "true" },
          title: "Pendaftaran AXI",
        },
      ],
    },
    {
      route_name: "gudang_info",
      title: "Gudang Info",
    },
  ],
  super_admin: [
    {
      route_name: "home",
      title: "Beranda",
    },
    {
      route_name: "profile",
      title: "Profil",
    },
    {
      title: "Produk Pembiayaan",
      group_route_name: "product",
      child: [
        {
          route_name: "produk_data_tunai_confirmation",
          title: "Dana Multi Guna",
        },
        {
          product_name: "maxi-travel",
          title: "Maxi Travel",
        },
        {
          product_name: "maxi-edukasi",
          title: "Maxi Edukasi",
        },
        {
          product_name: "maxi-usaha",
          title: "Maxi Usaha",
        },
        {
          product_name: "maxi-sehat",
          title: "Maxi Sehat",
        },
        {
          product_name: "maxi-extraguna",
          title: "Maxi Extraguna",
        },
      ],
    },
    {
      route_name: "simulasi_cicilan",
      title: "Simulasi Cicilan",
    },
    {
      route_name: "mitra_bisnis",
      title: "Mitra Bisnis",
    },
    {
      title: "AXI",
      group_route_name: "axi",
      role: "super admin",
      child: [
        {
          route_name: "axi_berita_terbaru_web",
          title: "Berita Terbaru",
        },
        {
          route_name: "axi_info",
          title: "Info AXI",
        },
        {
          route_name: "axi_unduh_materi",
          title: "Unduh Materi",
        },
        {
          route_name: "download_report_ppd",
          title: "Unduh Report PPD",
        },
        {
          route_name: "axi_unduh_epks",
          title: "Unduh EPKS",
        },
        {
          route_name: "axi_testimonial",
          title: "Kisah Sukses",
        },
        {
          route_name: "axi_register",
          title: "Daftarkan Rekan Bisnis",
        },
        {
          route_name: "axi_profile",
          title: "Profil Saya",
        },
      ],
    },
    {
      route_name: "gudang_info",
      title: "Gudang Info",
    },
  ],
};

export default Menu;
